<!DOCTYPE html>
<html lang="en">

<head>
  <meta charset="utf-8" />
  <meta http-equiv="X-UA-Compatible" content="IE=edge" />
  <meta name="viewport" content="width=device-width, initial-scale=1" />
  <title>403 - Acceso No Autorizado</title>
</head>

<body>
  <div class="cover">
    <h1>Usuario no Autorizado </h1>
    <p class="lead"> Usted no tiene autorización para este recurso o su token ha expirado. Por favor consultar en el sistema SUC</p>
  </div>

</body>

</html>